import React, { Component } from 'react';
import { Accordion, AccordionItem } from 'react-sanfona';
import moment from 'moment';
import { uuidv4 } from '../../../../utils/uuid';

import './styles.css';

class Occurrences extends Component {
  render() {
    const {
      currentManifest,
    } = this.props;

    return (
      <div className="ManifestsInTransit__Occurrences">
        <Accordion
          duration={0}
        >
          {currentManifest && currentManifest.deliveries.map(cte => (
            <AccordionItem
              key={cte.numCTe}
              className="NFTooltip__accordion-item"
              bodyClassName="NFTooltip__accordion-item-body NFTooltip__accordion-item-outside padding"
              title={`CTE-${cte.numCTe}`}
              expanded
            >
              <Accordion
                duration={0}
              >
                {cte.documents.map(document => (
                  <AccordionItem
                    key={document.nf}
                    className="NFTooltip__accordion-item"
                    bodyClassName="NFTooltip__accordion-item-body NFTooltip__accordion-item-outside padding"
                    title={`NF-${document.nf}-${document.nfGroup}`}
                    expanded
                  >
                    {document.occurrences.map(occurrence => (
                      <div
                        key={uuidv4()}
                        className="ManifestsInTransit--row"
                      >
                        <div className="ManifestsInTransit--col">
                          <p className="ManifestsInTransit--p ManifestsInTransit--label">Data da ocorrência:</p>
                          <p className="ManifestsInTransit--p">{currentManifest.date ? moment(occurrence.occurrenceDate).format('DD/MM/YYYY') : ''}</p>
                        </div>
                        <div className="ManifestsInTransit--col">
                          <p className="ManifestsInTransit--p ManifestsInTransit--label">Data de registro:</p>
                          <p className="ManifestsInTransit--p">{currentManifest.startDate ? moment(occurrence.registerDate).format('DD/MM/YYYY') : ''}</p>
                        </div>
                        <div className="ManifestsInTransit--col">
                          <p className="ManifestsInTransit--p ManifestsInTransit--label">Tipo:</p>
                          <p className="ManifestsInTransit--p">{occurrence.type}</p>
                        </div>
                        <div className="ManifestsInTransit--col">
                          <p className="ManifestsInTransit--p ManifestsInTransit--label">Observação:</p>
                          <p className="ManifestsInTransit--p">{occurrence.occurrenceText}</p>
                        </div>
                      </div>
                    ))}
                  </AccordionItem>
                ))}
              </Accordion>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    );
  }
}

export default Occurrences;
